
























































































import 'reflect-metadata'
import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import { AuthenticateApi, HomeApi, PlanningTransferApi } from "@/api"
import { config } from '@/config'

const AppInfo = namespace('app')
const Auth = namespace('authentication')

@Component
export default class App extends Vue { 
    drawer = true
	appVersion = config.version
	apiVersion = 0
	environment = config.environment
	tabColor = "#08223d"
	appName = ""
     
	isTemplateList = [
		'/login',
		'/viewdata/emailtransfer',
		'/viewdata/emailalertsummarytransfer',
		'/viewdata/unittransfered',
		'/viewdata/emailtransfersummary',
		'/viewdata/emailalertdaily',
		'/viewdata/emailalertseveninspection',
		'/viewdata/emailtransferdetail'
	]


	@AppInfo.State("appName") _appName!: string
	@AppInfo.State("menuLists") items!: any[]

	@Auth.State('auth') auth!: any

	@AppInfo.Action
    private MENU_LISTS!: (route: string) => Promise<any>

	@AppInfo.Action
    private CHECK_PERMISSION_REDIRECT!: (route: string) => Promise<any>

	async beforeMount () {
		await this.MENU_LISTS(this.$route.path)
	}
	
	async mounted () {

		//this.activeListMenu()
		const version = await HomeApi.Version()
        this.apiVersion = version
		console.log('-->', this.environment)
		console.log(this.$route.path)

		if (this.environment.toLowerCase() != "production") {
				this.tabColor = "#ff0000"
				this.appName = `${this._appName}-[**${this.environment}**]`
		} else {
				this.appName = `${this._appName}`
		}
	}

	async btnLogout () {

		try	{
	
			const logModel = {
                            application_name: "Transfer_Planning",
                            feature: "Logout Success",
                            page: "Logout",
                            json_data: JSON.stringify(this.auth),
                            created_by: this.auth.username,
                        };
                        PlanningTransferApi.addLog(logModel)
		} catch {

		}
		

		await AuthenticateApi.LogOutAd()
		localStorage.clear()
		this.$router.push('/login')
	}

}
